import { render, staticRenderFns } from "./Practitioner.vue?vue&type=template&id=5b5e83f4&scoped=true&"
import script from "./Practitioner.vue?vue&type=script&lang=js&"
export * from "./Practitioner.vue?vue&type=script&lang=js&"
import style0 from "./Practitioner.vue?vue&type=style&index=0&id=5b5e83f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5e83f4",
  null
  
)

export default component.exports